import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=19c5fb0a&scoped=true&"
import script from "./Favorites.vue?vue&type=script&lang=js&"
export * from "./Favorites.vue?vue&type=script&lang=js&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=19c5fb0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5fb0a",
  null
  
)

export default component.exports